import { render, staticRenderFns } from "./SlidePlaceholder.vue?vue&type=template&id=1051b556&scoped=true&"
import script from "./SlidePlaceholder.vue?vue&type=script&lang=js&"
export * from "./SlidePlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./SlidePlaceholder.vue?vue&type=style&index=0&id=1051b556&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1051b556",
  null
  
)

export default component.exports